import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { initializeAppRuntime } from './lib/appRuntime'
import { getDomainMigrationRedirect } from './lib/domainMigration'

// Resolve direct links before the account providers start.
if (typeof window !== 'undefined') {
  const target = getDomainMigrationRedirect(window.location);
  if (target) window.location.replace(target);
}

// Load cross-tab auth test utilities in development
if (process.env.NODE_ENV === 'development') {
  import('./utils/testCrossTabAuth.js');
  import('./utils/testAuthSync.js');
}

console.log('[main.jsx] Starting application...');

initializeAppRuntime();

// Create the React root and render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
); 
